interface PopupOptions {
  width?: number
  height?: number
  name?: string

  onMessage?: (type: string, payload: any) => void
  onClose?: () => void
}

const DEFAULT_WIDTH = 500
const DEFAULT_HEIGHT = 600

export function createPopup(url: string, options: PopupOptions) {
  const { width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT, name = 'Login', onMessage, onClose } = options

  // 回调函数
  const handles: { onMessage: (type: string, payload: any) => void; onClose: () => void } = {
    onMessage: null,
    onClose: null,
  }

  const left = window.screenX + (window.outerWidth - width) / 2
  const top = window.screenY + (window.outerHeight - height) / 2

  const popup = window.open(url, name, `width=${width},height=${height},left=${left},top=${top}`)

  if (!popup) {
    throw new Error('Failed to open popup')
  }

  // 监听popup的消息
  const handleMessage = (event: MessageEvent) => {
    if (event.source !== popup) return

    const { type, data } = event.data
    onMessage?.(type, data)
    handles.onMessage?.(type, data)
  }

  // 监听popup的消息
  window.addEventListener('message', handleMessage)

  const popupCheck = setInterval(() => {
    if (!popup || popup.closed) {
      onClose?.()
      handles.onClose?.()
      cleanup()
    }
  }, 200)

  const cleanup = () => {
    handles.onClose = null
    handles.onMessage = null

    clearInterval(popupCheck)
    window.removeEventListener('message', handleMessage)
  }

  const close = () => {
    cleanup()
    popup.close()
  }

  return { popup, cleanup, close, handles }
}

/**
 * 发送消息到父窗口
 * @param type 消息类型
 * @param data 消息数据
 */
export function sendToOpener(type: string, data: any, origin: string = '*') {
  if (!window.opener) return
  window.opener.postMessage({ type, data }, origin)
}

/**
 * 创建一个消息对象
 * @param origin 消息发送的源
 * @returns 消息对象
 */
export function createPopupMessage(origin: string = '*') {
  let _origin = origin
  return {
    setOrigin: (origin: string) => {
      _origin = origin
    },
    send: (type: string, data: any) => {
      sendToOpener(type, data, _origin)
    },
    emit: (type: string, data: any) => {
      sendToOpener(type, data, _origin)
    },
  }
}
